import { initialState } from './logState';
import type { RealtimeEventLog, RealtimeEventLogItem } from './types';

let state = initialState;

type SetLog = (newState: RealtimeEventLog) => void;
export const setLog: SetLog = (newState) => (state = newState);

type GetLog = () => RealtimeEventLog;
export const getLog: GetLog = () => state;

type GetLogEvents = () => RealtimeEventLogItem[];
export const getLogEvents: GetLogEvents = () => state.events;
